exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cookie[data-v-2795f2c3]{overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-2795f2c3","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/dialog/types/DialogCookieNotice.vue
// module id = 1077
// module chunks = 22